import type {
  WorkflowStageApproverInDto,
  WorkflowStageApproverOutDto,
  WorkflowStageOutDto,
} from './types';
import { sortByFractionalOrder } from 'helpers/sort';

type WorkflowApproverRef = Pick<WorkflowStageApproverInDto, 'userId'>;

export function normalizeWorkflowApprovers(
  approvers: readonly WorkflowApproverRef[] | undefined
): WorkflowStageApproverInDto[] {
  return (approvers ?? []).map((approver) => ({ userId: approver.userId }));
}

export function approverUserIdsToWorkflowApprovers(
  userIds: readonly string[]
): WorkflowStageApproverInDto[] {
  return normalizeWorkflowApprovers(userIds.map((userId) => ({ userId })));
}

export function areWorkflowApproversEqualByOrder(
  left: readonly WorkflowApproverRef[],
  right: readonly WorkflowApproverRef[]
): boolean {
  if (left.length !== right.length) {
    return false;
  }

  for (let index = 0; index < left.length; index += 1) {
    if (left[index].userId !== right[index].userId) {
      return false;
    }
  }

  return true;
}

export function getWorkflowOrderedApproverUserIds(
  stage: Pick<WorkflowStageOutDto, 'approvers'>
): string[] {
  return [...(stage.approvers ?? [])]
    .sort(sortByFractionalOrder)
    .map((approver) => approver.userId);
}